import logo from '../../../assets/onitLogo.svg'
const LogoSection = () => (
    <div style={{ marginLeft: '0%' }}>
        <img src={logo} style={{ width: '115px' }} />
    </div>
);

export default LogoSection;
